export default {
	apiGateway: {
		REGION: process.env.REACT_APP_AWS_REGION,
		URL: process.env.REACT_APP_API_URL, 
	},
	cognito: {
		REGION: process.env.REACT_APP_AWS_REGION,
		USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
		APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
		IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID
	},
	googleMaps: {
		GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
	},
	apiLog: {
		REGION: process.env.REACT_APP_AWS_REGION,
		URL: process.env.REACT_APP_GLOBAL_API,
},
	
};
